<div class="container">
  <app-page-header
    title="Seguimiento Infraestructura"
    subtitle="Gestiona y visualiza métricas de tickets SARI y costos de AWS"
    icon="chart">
  </app-page-header>

  <!-- Tabs Navigation -->
  <div class="tabs-container">
    <div class="tabs-nav">
      <button 
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'metricas'"
        (click)="selectTab('metricas')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M9 19v-6a2 2 0 00-2-2H5a2 2 0 00-2 2v6a2 2 0 002 2h2a2 2 0 002-2zm0 0V9a2 2 0 012-2h2a2 2 0 012 2v10m-6 0a2 2 0 002 2h2a2 2 0 002-2m0 0V5a2 2 0 012-2h2a2 2 0 012 2v14a2 2 0 01-2 2h-2a2 2 0 01-2-2z" />
        </svg>
        Métricas SARI
      </button>
      <button 
        type="button"
        class="tab-btn"
        [class.active]="activeTab === 'costos'"
        (click)="selectTab('costos')">
        <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke="currentColor">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 8c-1.657 0-3 .895-3 2s1.343 2 3 2 3 .895 3 2-1.343 2-3 2m0-8c1.11 0 2.08.402 2.599 1M12 8V7m0 1v8m0 0v1m0-1c-1.11 0-2.08-.402-2.599-1M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
        </svg>
        Ver Costos AWS
      </button>
    </div>
  </div>

  <!-- Tab Content -->
  <div class="tab-content">
    <div *ngIf="activeTab === 'metricas'" class="tab-panel">
      <app-sari-metrics></app-sari-metrics>
    </div>
    <div *ngIf="activeTab === 'costos'" class="tab-panel">
      <app-aws-costos></app-aws-costos>
    </div>
  </div>
</div>
